import React from 'react'
import i18next from 'i18next'
import { Link } from '../../utils/link'

export const Tags = (props: {
  tags: {
    title: string
    url: string
  }[]
}) =>
  props.tags.length > 0 ? (
    <aside className="block--tags container--m gutter--m">
      <div className="block__inner">
        <h2 className="block__title typo--xs">
          {i18next.t('misc:moreAbout')} <span className="sr-text">{i18next.t('misc:relatedSubjects')}</span>
        </h2>
        <ul className="block__list">
          {props.tags.map((tag) => (
            <li className="block__item">
              <Link url={tag.url} rel="tag" className="button--tag">
                <span className="button__label">{tag.title}</span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </aside>
  ) : (
    <></>
  )
